import { create } from 'zustand'; // Corrected import statement

export const useMediaStore = create((set) => ({
  imageUrls: [],
  videoUrls: [],
  isLoading: true,
  // setImageUrls: (urls) => set({ imageUrls: urls }),
  // setVideoUrls: (urls) => set({ videoUrls: urls }),
  setLoading: (loading) => set({ isLoading: loading }),

  setImageUrls: (urls) =>  set(state => {
    return { imageUrls: urls };
  }),
  setVideoUrls: (urls) =>  set(state => {
    return { videoUrls: urls };
  }),
}));
